import { ref, onMounted } from "vue";

export function usePopoverConfirmation(triggerRef, emit, options = {}) {
    const popover = ref(null);
    const popoverTarget = ref(null);
    const confirmingIdx = ref(null);

    onMounted(() => {
        popoverTarget.value = triggerRef.value?.$el || triggerRef.value;
    });

    function togglePopover(event) {
        popover.value?.toggle(event);
    }

    function closePopover() {
        popover.value?.hide();
    }

    function onHide() {
        // Optional: emit event or handle close
    }

    function handleItemClick(item, idx, closePopoverCallback) {
        const close = closePopoverCallback || closePopover;
        if (item.confirm) {
            confirmingIdx.value = idx;
        } else if (!item.disabled && item.onClick) {
            item.onClick(close);
        } else if (!item.disabled) {
            close();
        }
    }

    function handleConfirm(idx, closePopoverCallback, item) {
        const close = closePopoverCallback || closePopover;
        confirmingIdx.value = null;

        if (options.onConfirm) {
            options.onConfirm(item, close);
        } else {
            // Default behavior for BaseDelete and BaseConfirmation
            emit("update:modelValue", true);
            if (item.onConfirm) item.onConfirm(close);
            else close();
        }
    }

    function handleCancelConfirm(closePopoverCallback) {
        const close = closePopoverCallback || closePopover;
        confirmingIdx.value = null;
        if (options.onCancel) {
            options.onCancel(close);
        } else {
            // Default behavior
            emit("update:modelValue", false);
            close();
        }
    }

    return {
        popover,
        popoverTarget,
        confirmingIdx,
        togglePopover,
        closePopover,
        onHide,
        handleItemClick,
        handleConfirm,
        handleCancelConfirm,
    };
}
